/**
 * Multi-phone preview palette + colour helper.
 *
 * Originally this module also exported a `PhoneStrip` React component
 * (Whiteboard-style scaled-iframe thumb strip). When the preview overlay
 * was redesigned for Track B the strip was inlined into
 * `PreviewOverlay.tsx` with the persistent "FOCUSED" placeholder model,
 * and the `PhoneStrip`/`PhoneThumbnail` components became dead code —
 * removed 2026-05-22 (Cursor Bugbot review on PR #1066).
 *
 * What survives here is the palette + colour resolver, which the
 * redesigned overlay still consumes via `getPaneColour(idx)`. File name
 * kept for git-blame continuity; can be renamed in a follow-up if the
 * crucible-gui tree gets a `colours/` module.
 *
 * 2026-05-22: extended from 4 to 6 entries when the multi-phone cap
 * was raised from 4 to 6 (see `MAX_PREVIEW_PHONES` in
 * `dev-preview-urls.ts`). Player 1 is pinned to `#e8624a` to match
 * the Whiteboard design's accent (the focused-pane fallback in
 * `PreviewOverlay.tsx` already used this value). Players 2–6 are
 * chosen for high contrast against the dark overlay chrome and
 * distinguishable from each other at thumb size:
 *
 *   1 #e8624a — orange-red (Whiteboard accent)
 *   2 #3498db — blue
 *   3 #27ae60 — green
 *   4 #9b59b6 — purple
 *   5 #f1c40f — yellow
 *   6 #1abc9c — teal
 */
export const PLAYER_COLOURS = [
  '#e8624a',
  '#3498db',
  '#27ae60',
  '#9b59b6',
  '#f1c40f',
  '#1abc9c',
] as const;

/**
 * Resolve the chrome color for a given pane index. Beyond the
 * palette length we wrap around — Foundry's cap is currently 6 so
 * this never fires today, but keeps the helper defensive for future
 * bumps.
 */
export function getPaneColour(paneIndex: number): string {
  return PLAYER_COLOURS[paneIndex % PLAYER_COLOURS.length]!;
}
